import { Stack, Typography } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { FormikTextField } from '@components/FormikFields';

import { FeedbackEmailType } from 'generated/types';

interface FeedbackFormProps {
  type: FeedbackEmailType;
}

const messages = defineMessages({
  clientTitle: {
    id: 'feedbackModalContent.client.title',
    defaultMessage: 'Submit Feedback',
  },
  clientDescription: {
    id: 'feedbackModalContent.client.description',
    defaultMessage: 'Let us know how we can do better.',
  },
  clientFooter: {
    id: 'feedbackModalContent.client.footer',
    defaultMessage: 'Thank you for your feedback.',
  },
  emrTitle: {
    id: 'feedbackModalContent.emrConnection.title',
    defaultMessage: 'Hospital/Clinic Not Found?',
  },
  emrInstructions: {
    id: 'feedbackModalContent.emrConnection.instructions',
    defaultMessage:
      'Please provide us with the name, city, state/province, and country the hospital/clinic is located in.',
  },

  infoRequestTitle: {
    id: 'feedbackModalContent.infoRequest.title',
    defaultMessage: 'Information Request',
  },
  infoRequestSubtitle: {
    id: 'feedbackModalContent.infoRequest.subtitle',
    defaultMessage:
      'You have the right to request a copy of your personal information (PII and PHI) that VITALL processes. In accordance with privacy regulations, we are committed to transparency and protecting your data.',
  },
  infoRequestCopy: {
    id: 'feedbackModalContent.infoRequest.copy',
    defaultMessage:
      'Please use this form to initiate an information request by providing accurate and complete details so we can verify your identity and process your request efficiently. Once submitted, our team will review your request and respond within the required timeframe.',
  },
  required: {
    id: 'GLOBAL.required',
    defaultMessage: 'This field is required',
  },
});

export default function FeedbackForm({ type }: FeedbackFormProps) {
  const { formatMessage } = useIntl();

  let title = '';
  let subtitle = '';
  let copy = '';
  let footer = '';
  switch (type) {
    case FeedbackEmailType.Emr_Connection:
      title = formatMessage(messages.emrTitle);
      subtitle = formatMessage(messages.emrInstructions);
      break;
    case FeedbackEmailType.Information_Request:
      title = formatMessage(messages.infoRequestTitle);
      subtitle = formatMessage(messages.infoRequestSubtitle);
      copy = formatMessage(messages.infoRequestCopy);
      break;
    case FeedbackEmailType.Client_Feedback:
    default:
      title = formatMessage(messages.clientTitle);
      subtitle = formatMessage(messages.clientDescription);
      footer = formatMessage(messages.clientFooter);
      break;
  }

  return (
    <Stack rowGap={2}>
      <Typography color="primary.main" textAlign="center" variant="h5">
        {title}
      </Typography>

      <Typography textAlign="center" variant="body1">
        {subtitle}
      </Typography>

      {copy && (
        <Typography textAlign="center" variant="body1">
          {copy}
        </Typography>
      )}

      <FormikTextField name="message" required type="text-area" />

      {footer && (
        <Typography textAlign="center" variant="body1">
          {footer}
        </Typography>
      )}
    </Stack>
  );
}
